export default {
	Offline: 1,
	Online: 2
}
